<template>
  <div class="kpt-accesory-detail-modal card">
    <div class="card-image">
      <figure class="image">
        <img v-if="!product.assets" :src="require(`@/assets/configurator/placeholder.png`)" />
        <img v-else :src="`${assetCdnUrl.value}/${product.assets[0]}`" />
      </figure>
    </div>
    <div class="card-content">
      <div class="content">
        <h2 class="mb-1">{{ product.name }}</h2>
        <span class="is-uppercase">{{ product.productFamily }}</span>
        <br/>
        <span class="is-uppercase">{{ product.kpc }}</span>
        <template v-if="showPrices">
          <h6 class="mt-1 mb-4" v-if="wholesale.value">
            <span class="is-uppercase">Wholesale:</span>
            {{ product.wholesalePrice ? $numeral(product.wholesalePrice).format("$0,0") : 'N/A' }}
            <span class="ml-4 is-uppercase">MSRP:</span>
            {{ product.msrpPrice ? $numeral(product.msrpPrice).format("$0,0") : 'N/A' }}
          </h6>
          <div class="mt-1 mb-4" v-else>
            <span class="is-uppercase">MSRP:</span>
            {{ product.msrpPrice ? $numeral(product.msrpPrice).format("$0,0") : 'N/A' }}
          </div>
        </template>
        <div class="kpt-accessory-detail-about">
          <h5><strong>About</strong></h5>
          <p v-if="!product.description">Product description not found.</p>
          <p v-else v-html="product.description"></p>
        </div>
      </div>
      <div v-if="product.unavailable">
        <b-notification
          :closable="false"
          type="is-info is-light"
          aria-close-label="Close notification">
          This product may not be available at this time. Please contact your sales person.
        </b-notification>
      </div>
      <div class="is-flex is-justify-content-space-between mt-4">
        <b-button type="is-dark is-outlined is-small" @click="$emit('close')">Cancel</b-button>
        <div class="is-flex">
          <div class="mr-3">
            <b-field style="width: 125px; margin-bottom: 0">
            <b-numberinput
              size="is-small"
              max="999"
              min="1"
              v-model="addCount"
            ></b-numberinput>
          </b-field>
          </div>
          <b-button
            rounded
            size="is-small"
            type="is-dark"
            @click="addToCart"
            >ADD</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue';

export default {
  props: ['product', 'wholesale', 'showPrices', 'assetCdnUrl'],
  setup(props, { emit }) {
    const addCount = ref(1);
    const addToCart = () => {
      emit('addToCart', addCount);
      emit('close');
    }

    return {
      addCount,
      addToCart
    }
  }
};
</script>
<style lang="scss" scoped>
  .kpt-accesory-detail-modal {
    .kpt-accessory-detail-about {
      ::v-deep p {
        margin-top: 0px;
        margin-bottom: 0px;
      }
    }
  }
</style>
